// JsFromRoutes CacheKey e7cb16a52f9564a67ae7b7627be7013f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/files/:signed_id'),
}
